import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LazyImage from "@/components/utils/LazyImage.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileImageLazy',
  props: {
  user: Object,
  rawImage: String||null,
  premiumCube: Boolean,
  customClass: Object||Array,
},
  setup(__props) {



/*
defineProps<{
  user: object;
  rawImage: string;
  premiumCube: boolean;
  customClass: Array<unknown>|object,
}>();
 */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LazyImage, {
    classList: ['transition duration-150 w-20 h-20 rounded-full mx-auto', {'!rounded-md': __props.premiumCube}, __props.customClass],
    "loader-class": ['transition duration-150 w-20 h-20 rounded-full mx-auto', {'!rounded-md': __props.premiumCube}, __props.customClass],
    src: __props.rawImage ? __props.rawImage : _ctx.$profileImage(__props.user.profile_image_path),
    alt: "Profile Image"
  }, null, 8, ["classList", "loader-class", "src"]))
}
}

})